export { default as GeneralSettingTab }           from './General_Settings_Tab';
export { default as TranslationsTab }             from './Translations_Tab';
export { default as NewUserRegistrationTab }      from './New_User_Registration_Tab';
export { default as AdminEmailSettingTab }        from './Admin_Email_Setting_Tab';
export { default as NotificationTab }             from './Notification_Tab';
export { default as UserManagementTab }           from './UserManagementTab';
